import React, {useCallback, useState, useMemo} from 'react';
import {Select, Input, Button} from 'antd';
import {IncidentStatuses} from '../../../../../store/incident/utils';
import {tid} from '../../../../../testUtils';
import {EditOutlined} from '@ant-design/icons';
import {IncidentStatus} from 'hemwb-api';
import styles from './UpdateIncidentForm.module.scss';

type UpdateIncidentFormProps = {
  status?: string;
  submitting: boolean;
  onSubmit?: (status: IncidentStatus, comments: string) => void;
  onCancel?: () => void;
};

const UpdateIncidentForm: React.FC<UpdateIncidentFormProps> = ({status, onCancel, submitting, onSubmit}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>(status || '');
  const [comments, setComments] = useState<string>('');

  const handleSubmit = useCallback(() => {
    if (selectedStatus && comments.trim()) {
      onSubmit?.(selectedStatus as IncidentStatus, comments);
    }
  }, [selectedStatus, comments, onSubmit]);

  const isSubmitDisabled = useMemo(() => {
    return status === 'CLOSED' || status === selectedStatus || !selectedStatus || !comments.trim() || submitting;
  }, [status, selectedStatus, comments, submitting]);

  const statusOptions = useMemo(
    () =>
      IncidentStatuses.map((st) => ({
        label: st,
        value: st,
      })),
    [],
  );

  return (
    <div className={styles.formContainer}>
      <div className={styles.formGroup}>
        <label className={styles.label}>
          Status <span className={styles.required}>*</span>
        </label>
        <div className={styles.statusSelect}>
          <Select
            style={{fontSize: '14px'}}
            value={selectedStatus}
            onChange={setSelectedStatus}
            options={statusOptions}
            placeholder="Select status"
            {...tid('input', 'status')}
          />
        </div>
      </div>

      <div className={styles.formGroup}>
        <label className={styles.label}>
          Add closing comment for the user <span className={styles.required}>*</span>
        </label>
        <div className={styles.commentTextarea}>
          <Input.TextArea
            style={{fontSize: '14px'}}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder="Textarea"
            rows={6}
            {...tid('input', 'comments')}
          />
        </div>
      </div>

      <div className={styles.buttonsContainer}>
        <Button onClick={onCancel} disabled={submitting} className={styles.cancelBtn}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={submitting}
          disabled={isSubmitDisabled}
          icon={<EditOutlined />}
          className={styles.submitBtn}
        >
          Update Incident
        </Button>
      </div>
    </div>
  );
};

export default UpdateIncidentForm;
